import { render } from "./TypeEdit.vue?vue&type=template&id=0b7eaf18"
import script from "./TypeEdit.vue?vue&type=script&lang=js"
export * from "./TypeEdit.vue?vue&type=script&lang=js"
script.render = render

export default script